
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trademarking",
      function () {
        return require("private-next-pages/trademarking.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trademarking"])
      });
    }
  